import styled from "styled-components";

export const MReferralHistorySection = styled.div`
  width: 100%;
  height: 100%;
  padding: 16px;
`;
